import resolveResponse from 'contentful-resolve-response';

const resolvedData = content => resolveResponse(JSON.parse(content));

export default resolvedData;
